import { render, staticRenderFns } from "./releaseNoteCard.vue?vue&type=template&id=0f31e234"
var script = {}
import style0 from "./releaseNoteCard.vue?vue&type=style&index=0&id=0f31e234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports